<header class="mb-10 flex items-center px-8 pt-10">
    <div class="flex items-center">
        <mat-icon class="mr-5 scale-150">person</mat-icon>
        <h1 class="text-3xl font-medium">User search</h1>
    </div>
</header>
<form
    class="flex flex-col py-10"
    [formGroup]="form">
    <div class="flex items-center justify-center gap-x-4">
        <mat-form-field class="w-1/2">
            <mat-label>Email or ProfileId</mat-label>
            <mat-icon matIconPrefix>search</mat-icon>
            <input
                matInput
                formControlName="email" />
        </mat-form-field>
        <button
            class="-mt-6"
            mat-flat-button
            color="primary"
            [disabled]="form.invalid"
            (click)="search()">
            Search
        </button>
    </div>
</form>
